import { FormattedMessage } from "react-intl";
import "./TechnicalErrorSSO.scss";
import { getOauthIndentityProviderUrl } from "app/utils/auth";
import { parseQueries } from "app/utils/routerUtils";
import { useLocation } from "react-router-dom";
import { memo, useContext } from "react";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import AppGlobalsContext from "app/AppGlobalsContext";

const TechnicalErrorSSO = () => {
	const location = useLocation();
	const query = parseQueries(location.search);
	const { redirectUri } = query;
	const { envVars } = useContext(AppGlobalsContext);
	const environment = envVars.ENVIRONMENT;

	return (
		<div className="technical-error">
			<div className="technical-error__intro">
				<FormattedMessage id="technical.sso.error.message" />

				<div className="technical-error__cta">
					<Button
						variant={BUTTON_VARIANTS.FILLED}
						size={BUTTON_SIZES.LARGE}
						label={<FormattedMessage id="technical.sso.cta.label" />}
						to={getOauthIndentityProviderUrl(redirectUri, environment)}
						data-testid={"go-to-login-button"}
					/>
				</div>
			</div>
		</div>
	);
};

export default memo(TechnicalErrorSSO);
